import { SkeletonBlock } from '@/components/common/skeleton';

import styles from './page-skeleton.module.scss';

export type PageSkeletonProps = {
  /** Number of body card placeholders. Defaults to 6. */
  count?: number;
};

/**
 * Generic page-shell placeholder shown while a lazy route chunk loads (route-level
 * navigation fallback). Renders a title + toolbar + body grid so the page frame appears
 * immediately instead of a frozen/blank screen during navigation.
 */
export function PageSkeleton({ count = 6 }: PageSkeletonProps) {
  return (
    <div className={styles.page} aria-busy="true" aria-label="Loading">
      <SkeletonBlock width={200} height={28} />

      <div className={styles.toolbar}>
        <div className={styles.toolbarLeft}>
          <SkeletonBlock width={72} height={36} radius={999} />
          <SkeletonBlock width={72} height={36} radius={999} />
          <SkeletonBlock width={72} height={36} radius={999} />
        </div>
        <div className={styles.toolbarRight}>
          <SkeletonBlock width={220} height={40} radius={10} />
          <SkeletonBlock width={40} height={40} radius={10} />
        </div>
      </div>

      <div className={styles.grid}>
        {Array.from({ length: count }, (_, i) => (
          <SkeletonBlock key={i} className={styles.card} />
        ))}
      </div>
    </div>
  );
}
